import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Smoothly scroll to top whenever the pathname changes.
 * Mount once inside <BrowserRouter> (e.g. before <Routes>).
 *
 * - Respects "prefers-reduced-motion" (uses instant scroll for accessibility)
 * - Skips scrolling if user navigated to a hash anchor (#section)
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let the browser handle anchor links naturally

    const reduceMotion =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: reduceMotion ? "auto" : "smooth",
    });
  }, [pathname, hash]);

  return null;
}
